// Redux-agnostic catalog fetch, shared by useProposalCatalog and
// usePurchaseLinkCatalog (previously two near-identical copies of this same
// fetch-loading-error-refetch wrapper, one per Redux slice). Mirrors
// usePaymentPreview's shape — this hook doesn't know which slice the caller
// stores the result in, it just resolves the catalog and hands it back via
// onCatalogLoaded.
import {useEffect, useState, useCallback} from 'react'
import {useAuthClient} from '../../../utils/use-auth-client'
import {fetchProductConfig} from '../../../utils/fetchProductConfig'
import {applyProductRulesBeforeLoading} from '../utils/productPreloadRules'
import {useUserFeatures} from '../../../context/user-features-context'

export function useProductCatalogFetch({onCatalogLoaded}) {
  const client = useAuthClient()
  const userFeatures = useUserFeatures()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchCatalog = useCallback(async () => {
    try {
      setLoading(true)

      const {all5PlanPrices} = await fetchProductConfig(client)

      const resolvedCatalog = applyProductRulesBeforeLoading(
        all5PlanPrices,
        userFeatures,
      )
      onCatalogLoaded(resolvedCatalog)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [client, userFeatures, onCatalogLoaded])

  useEffect(() => {
    fetchCatalog()
  }, [fetchCatalog])

  return {
    loading,
    error,
    refetch: fetchCatalog,
  }
}
